import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Image } from '@chakra-ui/react';
import { AutoSizer } from 'react-virtualized';
const SmartImageFC = ({ src, height, onLoadingChanged }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        onLoadingChanged?.(isLoading);
    }, [isLoading, onLoadingChanged]);
    return (_jsx(Box, { w: '100%', position: 'relative', children: _jsx(AutoSizer, { disableHeight: true, children: ({ width }) => {
                return (_jsxs(Box, { w: `${width}px`, children: [(isLoading || isError) && (_jsx(Box, { position: 'absolute', bg: '{gradients.image_loading}', className: isLoading ? 'blinking' : '', bottom: 0, right: 0, left: 0, top: 0 })), _jsx(Image, { src: src, w: `${width}px`, h: `${height}px`, objectFit: 'contain', opacity: isLoading ? 0 : 1, transition: 'opacity var(--tr-150-ei)', onError: () => setIsError(true), onLoad: () => setIsLoading(false) })] }));
            } }) }));
};
export const SmartImage = SmartImageFC;
//# sourceMappingURL=SmartImage.js.map